module.exports = __webpack_public_path__ + "img/df49d5e.svg";